import React from 'react';
import { isLowEnd, isMidEnd } from '../lib/usePerf';

/**
 * Ember Circuit background — grid + diagonal light beams + orbs + scanline
 * OPTIMIZED: low-end gets simplified version (no blur, fewer elements)
 */
export const MovingBG = () => {
  // Low-end: just grid + vignette, no animated orbs/beams/scanline
  if (isLowEnd) {
    return (
      <div className="moving-bg" aria-hidden="true">
        <div className="mb-grid" />
        <div className="mb-vignette" />
      </div>
    );
  }

  // Mid-end: grid + orbs (no blur class) + vignette, skip beams & scanline
  if (isMidEnd) {
    return (
      <div className="moving-bg" aria-hidden="true">
        <div className="mb-grid" />
        <div className="mb-orb-1 mb-no-blur" />
        <div className="mb-orb-2 mb-no-blur" />
        <div className="mb-vignette" />
      </div>
    );
  }

  // High-end: full experience
  return (
    <div className="moving-bg" aria-hidden="true">
      <div className="mb-grid" />
      <div className="mb-orb-1" />
      <div className="mb-orb-2" />
      <div className="mb-orb-3" />
      <div className="mb-beam mb-beam-1" />
      <div className="mb-beam mb-beam-2" />
      <div className="mb-beam mb-beam-3" />
      <div className="mb-scan" />
      <div className="mb-vignette" />
    </div>
  );
};
